import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ApiAgentService} from '../../../services/api-agent.service';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '../../../services/environment.service';
import {firstValueFrom} from 'rxjs';
import {WebsitePage} from '../../../models/website-page';
import {HeroBannerFormComponent} from './widgets/hero-banner-form/hero-banner-form.component';
import {HtmlContentComponent} from './widgets/html-content/html-content.component';
import {HtmlBlock, PageContent} from '../../../models/page-content';
import {UtilsService} from '../../../services/utils.service';
import {HeroBanner} from '../../../models/html-content';
import {CommonModule} from '@angular/common';

declare var Snackbar: any;
const CONSOLE_PREFIX = 'website page - ';

// noinspection DuplicatedCode
@Component({
  selector: 'app-website-page',
  templateUrl: './website-page.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./website-page.component.scss']
})
export class WebsitePageComponent implements OnInit {

  pageForm: FormGroup;
  loading: boolean;
  @ViewChild(HeroBannerFormComponent) heroBannerFormComponent: HeroBannerFormComponent;
  @ViewChild(HtmlContentComponent) htmlContentComponent: HtmlContentComponent;

  submitted: boolean;
  formStatus: string;
  websitePageId: any;
  websitePageFromServer: WebsitePage;

  subAccountType: any;
  subAccountGovId: any;
  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;
  lang: any;
  @ViewChild('ckEditorContent') ckEditorContent: ElementRef;

  pageType: any;
  heroBannerServerData: HeroBanner[];
  htmlBlockServerData: HtmlBlock[];


  checkPermission() {
    this.activatedRouter.queryParams.subscribe(params => {
      let perms = this.environmentService.checkPermission(params['type'], params['govId']);
      this.isAccountant = perms.isAccountant;
      this.isSales = perms.isSales;
      this.isManager = perms.isManager;
      this.isMerchant = perms.isMerchant;
    });
  }

  constructor(private activatedRouter: ActivatedRoute,
              private translate: TranslateService,
              private loader: GlobalLoaderService,
              private utils: UtilsService,
              private environmentService: EnvironmentService,
              private http: HttpClient,
              private formBuilder: FormBuilder,
              private router: Router,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.loading = true;
    this.lang = await firstValueFrom(this.translate.get('lang'));
    this.pageForm = this.formBuilder.group({
      name: [''],
      name_ar: ['', [Validators.required]],
      url: ['', [Validators.required]],
      type: ['', [Validators.required]],
      description: [''],
      description_ar: [''],
      content: [''],
    });

    // @ts-ignore
    this.pageForm.get('type').valueChanges.subscribe(val => {
      this.pageType = val;
      console.log(CONSOLE_PREFIX + '(ngOnInit) - page type', this.pageType);
    });

    await this.loadResources();

    this.activatedRouter.params.subscribe(async params => {
      this.formStatus = params['status'];
      this.websitePageId = params['websitePageId'];
      if (this.websitePageId) {
        await this.loadWebsitePageData();
        this.loading = false;
      } else {
        this.loading = false;
      }
      this.checkPermission();
    });
  }

  async loadWebsitePageData() {

    // load the webpage data from the server
    this.websitePageFromServer = await this.api.loadWebsitePage(this.websitePageId);

    // process the webpage data
    console.log(CONSOLE_PREFIX + '(loadWebsitePageData) - this.websitePageFromServer before', this.websitePageFromServer);
    this.websitePageFromServer.name_locale = this.utils.processResponse(this.websitePageFromServer.name_locale);
    this.websitePageFromServer.description_locale = this.utils.processResponse(this.websitePageFromServer.description_locale);

    // process the content of the webpage
    if (this.websitePageFromServer.type == 'home') {
      this.websitePageFromServer.content = this.utils.processResponse(this.websitePageFromServer.content);
    }

    // load the webpage data into the form
    console.log(CONSOLE_PREFIX + '(loadWebsitePageData) - this.websitePageFromServer after', this.websitePageFromServer);
    this.pageForm.patchValue({
      name: this.websitePageFromServer.name,
      name_ar: this.websitePageFromServer.name_locale && this.websitePageFromServer.name_locale[this.lang] ? this.websitePageFromServer.name_locale[this.lang] : null, // latertodo: ensure that this.lang is exists.
      url: this.websitePageFromServer.url,
      type: this.websitePageFromServer.type == 'home' ? 'home' : 'general',
      description: this.websitePageFromServer.description,
      description_ar: this.websitePageFromServer.description_locale && this.websitePageFromServer.description_locale[this.lang] ? this.websitePageFromServer.description_locale[this.lang] : null,
      content: this.websitePageFromServer.content,
    });

    // load the webpage data into the widgets
    console.log(CONSOLE_PREFIX + '(loadWebsitePageData) - this.websitePageFromServer.type', this.websitePageFromServer.type);

    let pageContent: PageContent = this.websitePageFromServer.content;
    console.log(CONSOLE_PREFIX + '(loadWebsitePageData) - pageContent 144', pageContent);
    this.heroBannerServerData = pageContent.heroBanners;
    console.log(CONSOLE_PREFIX + '(loadWebsitePageData) - this.heroBannerServerData 146', this.heroBannerServerData);

    if (this.websitePageFromServer.content.htmlBlocks != null) {
      this.htmlBlockServerData = this.websitePageFromServer.content.htmlBlocks;
    } else if (typeof this.websitePageFromServer.content == 'string') {
      this.htmlBlockServerData = [{
        uid: 0,
        content: this.websitePageFromServer.content,
        type: 'html',
        backgroundColor: '#ffffff'
      }];
    }

    console.log(CONSOLE_PREFIX + '(loadWebsitePageData) - this.htmlBlockServerData 156', this.htmlBlockServerData);

    if (this.websitePageFromServer.type == 'products' && typeof this.websitePageFromServer.content == 'string') {
      if (this.htmlBlockServerData.length == 0) {
        this.htmlBlockServerData = [];
      }
      this.htmlBlockServerData.push({
        uid: 0,
        content: [{value: 'all', full: 'All - الكل'}],
        type: 'products',
        backgroundColor: '#ffffff'
      });
    }
  }

  //
  async loadResources() {
    // load external javascript libraries.
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalStyles('/plugins/file-upload/file-upload-with-preview.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalScript('/plugins/file-upload/file-upload-with-preview.min.js');
    await this.loader.loadExternalStyles('https://cdn.quilljs.com/1.3.6/quill.snow.css');
    await this.loader.loadExternalScript('/assets/js/tinymce/js/tinymce/tinymce.min.js');
  }

  // @ts-ignore
  get f() {
    return this.pageForm.controls;
  }

  showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  cleanImage(thumbnailImage) {
    const prefixRegex = /^data:image\/\w+;base64,/;
    if (prefixRegex.test(thumbnailImage)) {
      return thumbnailImage.replace(prefixRegex, '');
    }
    return thumbnailImage;
  }

  async sendDataToServer() {

    // get values of the webspage
    let name = this.pageForm.value['name'];
    let name_ar = this.pageForm.value['name_ar'];
    let url = this.pageForm.value['url'];
    let type = this.pageForm.value['type'];
    let description = this.pageForm.value['description'];
    let description_ar = this.pageForm.value['description_ar'];
    let content: PageContent = {
      heroBanners: [],
      featuredProducts: null,
      categoriesPreview: null,
      aboutUs: null,
      testimonials: null,
      latestBlogPosts: null,
      htmlBlocks: []
    };

    console.log(CONSOLE_PREFIX + '(sendDataToServer) - content', content);
    console.log(CONSOLE_PREFIX + '(sendDataToServer) - name', name);

    // fill the HTML blocks array with the content of the htmlBlocks array
    let htmlBlocks = this.htmlContentComponent.htmlBlocks.value;
    console.log(CONSOLE_PREFIX + '(sendDataToServer) - htmlBlocks', htmlBlocks);
    let htmlBlocksArray: HtmlBlock[] = [];
    for (let i = 0; i < htmlBlocks.length; i++) {
      if (htmlBlocks[i].content) {
        htmlBlocksArray.push({
          choices: htmlBlocks[i].choices,
          uid: htmlBlocks[i].uid,
          content: htmlBlocks[i].content,
          backgroundColor: htmlBlocks[i].backgroundColor,
          type: htmlBlocks[i].type,
          title: htmlBlocks[i].title,
          titleColor: htmlBlocks[i].titleColor
        });
      }
    }

    console.log(CONSOLE_PREFIX + '(sendDataToServer) - htmlBlocksArray', htmlBlocksArray);
    content.htmlBlocks = htmlBlocksArray;

    // special for home page
    if (this.pageType == 'home') {
      // get hero banner data from the form array
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - this.heroBannerFormComponent', this.heroBannerFormComponent);
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - this.heroBannerFormComponent.heroBannerForm', this.heroBannerFormComponent.heroBannerForm);
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - this.heroBannerFormComponent.heroBannerForm.valid', this.heroBannerFormComponent.heroBannerForm.valid);

      let formValue: any[] = this.heroBannerFormComponent.heroBanners.value;

      for (let i = 0; i < formValue.length; i++) {
        if (formValue[i].imageUrl) {
          content.heroBanners.push({
            backgroundColor: formValue[i].backgroundColor,
            headline: formValue[i].headline,
            subHeadLineColor: formValue[i].subHeadLineColor,
            headlineColor: formValue[i].headlineColor,
            subHeadline_locale: {ar: formValue[i].subHeadline_ar},
            headline_locale: {ar: formValue[i].headline_ar},
            subHeadline: formValue[i].subHeadline,
            imageUrl: this.cleanImage(formValue[i].imageUrl)
          });
        } else {
          console.log(CONSOLE_PREFIX + '(sendDataToServer) - ignore because empty image url:', formValue[i].imageUrl);
        }
      }
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - homeContent:', content);
    }

    try {
      // fill webpage object with the data
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - website page payload to be');
      let websitePage: WebsitePage = {
        id: this.formStatus == 'edit' ? this.websitePageFromServer.id : null,
        merchantId: null,
        name: name,
        name_locale: {ar: name_ar},
        url: url,
        rank: this.formStatus == 'edit' && this.websitePageFromServer.rank ? this.websitePageFromServer.rank : null,
        type: type,
        description: description,
        description_locale: {ar: description_ar},
        content: content
      };

      // send the webpage object to the server
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - website page payload', websitePage);
      let newWebsitePage: WebsitePage = await this.api.postWebsitePage(websitePage);
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - edited websitePage', newWebsitePage);
      this.websitePageId = newWebsitePage.id;

      // show success message and navigate to the webpages list
      await this.loadWebsitePageData();
      this.showToast(await firstValueFrom(this.translate.get('WebsitePage saved successfully')));
      this.router.navigate(['/private', 'webpages']).then();
    } catch (e) {
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - error', e);
      this.showToast(await firstValueFrom(this.translate.get('Could not save the websitePage')));
    } finally {
      this.loading = false;
    }
  }

  async submitForm() {
    this.submitted = true;
    console.log(CONSOLE_PREFIX + '(sendDataToServer) - to validate');
    if (this.pageForm.valid) {
      this.loading = true;
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - submitting');
      await this.sendDataToServer();
    } else {
      console.log(CONSOLE_PREFIX + '(sendDataToServer) - errors', this.pageForm.errors);
    }
  }

  handlePageTypeChange() {
    if (this.pageForm.controls['url'].value == '') {
      this.pageForm.controls['url'].setValue(this.pageForm.controls['type'].value);
    }
  }
}
